import { PlanMetadataTypes } from '@mode/shared/contract-common';
import { Observable } from 'rxjs';

export interface PlanPaging {
  planMetadataId: PlanMetadataTypes.PlanMetadataId;
  offset: number;
  pageSize: number;
}

export abstract class PlanMetadataFacade {
  abstract createPagingSelector(planMetadataId: PlanMetadataTypes.PlanMetadataId): Observable<PlanPaging | undefined>;
  abstract createOffsetSelector(planMetadataId: PlanMetadataTypes.PlanMetadataId): Observable<number | undefined>;
  abstract createPageSizeSelector(planMetadataId: PlanMetadataTypes.PlanMetadataId): Observable<number | undefined>;

  abstract initPaging(planMetadataId: PlanMetadataTypes.PlanMetadataId, offset?: number, pageSize?: number): void;
  abstract initPagingIfUnset(
    planMetadataId: PlanMetadataTypes.PlanMetadataId,
    offset?: number,
    pageSize?: number
  ): void;
  abstract setOffsetInDesigner(vizToken: string, offset: number): void;
  abstract setPageSizeInDesigner(vizToken: string, pageSize: number, offset?: number): void;
  abstract setOffsetRawResults(queryToken: string, offset: number): void;
  abstract setOffsetWithCalcs(queryToken: string, offset: number): void;
}
